import Vue from 'vue'
import Vuex from 'vuex'

// import modules from './modules'
import { account } from './modules/account'
import { users } from './modules/user'
import { customers } from './modules/customer'
import { geo } from './modules/geo'
import { invoice } from './modules/invoice'
import { app } from './modules/app'
import { settings } from './modules/settings'
import { employees } from './modules/employees'
import { notifications } from './modules/notifications'
import { companyProfiles } from './modules/companyProfiles'
import { inquiries } from './modules/inquiries'
import { activityLogs } from './modules/activityLogs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    account,
    users,
    customers,
    geo,
    invoice,
    app,
    settings,
    employees,
    notifications,
    companyProfiles,
    inquiries,
    activityLogs
  },
  plugins: [    
    // createSharedMutations()
  ],
  strict: process.env.NODE_ENV !== 'production'
})
